export default function Features() {
  const features = [
    {
      icon: 'ri-heart-fill',
      title: 'Loving Care',
      description: 'Every pet receives personalized attention and affection from our dedicated team who treat them like family.',
      color: 'from-[#FFE5EC] to-[#FFD1DC]',
      iconColor: 'text-[#FF9B9B]',
      decorative: 'ri-footprint-fill',
      decorativeColor: 'text-[#FFD1DC]',
    },
    {
      icon: 'ri-shield-check-fill',
      title: 'Safe Environment',
      description: 'Our facility is designed with your pet\'s safety in mind, featuring secure spaces and constant supervision.',
      color: 'from-[#E6E0F5] to-[#D4C5F0]',
      iconColor: 'text-[#8B7BA8]',
      decorative: 'ri-star-fill',
      decorativeColor: 'text-[#D4C5F0]',
    },
    {
      icon: 'ri-heart-pulse-fill',
      title: 'Expert Veterinarians',
      description: 'Our certified veterinarians provide top-quality medical care and health monitoring for your beloved pets.',
      color: 'from-[#D4F4DD] to-[#B8E6C9]',
      iconColor: 'text-[#5FB878]',
      decorative: 'ri-leaf-fill',
      decorativeColor: 'text-[#B8E6C9]',
    },
  ];

  return (
    <section id="services" className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 animate-fade-in-up">
          <div className="w-16 h-1 bg-[#D4C5F0] mx-auto mb-6 rounded-full"></div>
          <h2 className="text-5xl font-bold text-[#4A3B5C] mb-4 font-heading">
            Why Pets Love Us
          </h2>
          <p className="text-[#8B7BA8] text-lg">Providing the best care for your furry friends</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className={`bg-white rounded-[32px] p-12 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 relative overflow-hidden cursor-pointer animate-scale-in animate-delay-${(index + 2) * 100}`}
            >
              <div className={`w-20 h-20 flex items-center justify-center rounded-full bg-gradient-to-br ${feature.color} mb-6 shadow-md`}>
                <i className={`${feature.icon} text-white text-3xl`}></i>
              </div>

              <h3 className="text-2xl font-bold text-[#4A3B5C] mb-4 font-heading">
                {feature.title}
              </h3>

              <p className="text-[#8B7BA8] leading-relaxed">{feature.description}</p>

              <i className={`${feature.decorative} ${feature.decorativeColor} text-4xl absolute bottom-6 right-6 opacity-20`}></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
